<div class="auth-shell">

  <!-- ============ LEFT · BRAND HERO ============ -->
  <aside class="auth-hero">
    <div class="hero-inner">
      <div class="hero-logo">
        <img src="../../../assets/arogyaLOGO.png" alt="Arogya Kavach" />
      </div>

      <div class="hero-copy">
        <h1 class="hero-title">Smart Solutions<br />for a <span>Healthier Tomorrow</span></h1>
        <p class="hero-lede">Secure. Reliable. Dedicated to protecting what matters most.</p>
      </div>

      <ul class="hero-features">
        <li>
          <span class="hf-ico"><i class="pi pi-shield"></i></span>
          <div><b>Secure Access</b><small>Your data is protected with advanced security</small></div>
        </li>
        <li>
          <span class="hf-ico"><i class="pi pi-users"></i></span>
          <div><b>Easy &amp; Reliable</b><small>Seamless access to your information anytime</small></div>
        </li>
        <li>
          <span class="hf-ico"><i class="pi pi-heart"></i></span>
          <div><b>Better Healthcare</b><small>Technology driven solutions for better outcomes</small></div>
        </li>
      </ul>

      <div class="hero-shield" aria-hidden="true">
        <svg viewBox="0 0 200 230" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="shieldFill" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0" stop-color="#eaf6ff" />
              <stop offset="0.5" stop-color="#8fd0f5" />
              <stop offset="1" stop-color="#2f7fd1" />
            </linearGradient>
            <linearGradient id="shieldEdge" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0" stop-color="#ffffff" />
              <stop offset="1" stop-color="#cfe6f7" />
            </linearGradient>
          </defs>
          <ellipse class="shield-halo" cx="100" cy="150" rx="86" ry="22" />
          <path class="shield-edge" d="M100 8 L182 40 V120 C182 170 146 205 100 222 C54 205 18 170 18 120 V40 Z"
                fill="url(#shieldEdge)" />
          <path d="M100 20 L170 47 V119 C170 162 140 193 100 208 C60 193 30 162 30 119 V47 Z"
                fill="url(#shieldFill)" />
          <path class="shield-cross" d="M88 78 H112 V102 H136 V126 H112 V150 H88 V126 H64 V102 H88 Z" fill="#ffffff" />
        </svg>
      </div>

      <p class="hero-trust"><i class="pi pi-verified"></i> Your trust is our commitment.</p>

      <div class="hero-powered">
        <span>Powered by</span>
        <span class="lapitech-badge">
          <img src="../../../assets/lapitech-logo-full.png?v=2" alt="Lapitech Software Solutions" />
        </span>
      </div>
    </div>
  </aside>

  <!-- ============ RIGHT · SIGN-IN ============ -->
  <main class="auth-panel">
    <div class="auth-card">

      <!-- Password / OTP switch -->
      <div class="mode-pills">
        <button type="button" class="pill" [class.active]="mode() === 'password'" (click)="setMode('password')">
          <i class="pi pi-lock"></i> Password
        </button>
        <button type="button" class="pill" [class.active]="mode() === 'otp'" (click)="setMode('otp')">
          <i class="pi pi-mobile"></i> OTP
        </button>
      </div>

      <h2 class="auth-welcome">Welcome <span>Back!</span></h2>
      <p class="auth-sub">Sign in with your credentials to continue</p>

      <form [formGroup]="loginForm" (ngSubmit)="onLogin()" class="auth-form">
        <div class="field">
          <span class="field-ico"><i class="pi pi-user"></i></span>
          <input type="text" formControlName="username" placeholder="Username" autocomplete="username" />
        </div>
        @if (loginForm.get('username')?.touched && loginForm.get('username')?.invalid) {
          <small class="field-err">Username is required</small>
        }

        @if (!isOtpLogin) {
          <div class="field">
            <span class="field-ico"><i class="pi pi-lock"></i></span>
            <input [type]="showPassword() ? 'text' : 'password'" formControlName="password"
                   placeholder="Password" autocomplete="current-password" />
            <button type="button" class="field-eye" (click)="showPassword.set(!showPassword())"
                    [attr.aria-label]="showPassword() ? 'Hide password' : 'Show password'">
              <i class="pi" [class.pi-eye]="!showPassword()" [class.pi-eye-slash]="showPassword()"></i>
            </button>
          </div>
          @if (loginForm.get('password')?.touched && loginForm.get('password')?.invalid) {
            <small class="field-err">Password is required</small>
          }
        }

        <div class="auth-row">
          <label class="remember">
            <input type="checkbox" formControlName="rememberMe" />
            <span>Remember me</span>
          </label>
          <a class="forgot" routerLink="/forgot-password">Forgot password?</a>
        </div>

        <button class="auth-submit" type="submit" [disabled]="loading()">
          @if (loading()) {
            <span class="spinner-border spinner-border-sm"></span> Please wait…
          } @else {
            {{ isOtpLogin ? 'Send OTP' : 'Sign In' }} <i class="pi pi-arrow-right"></i>
          }
        </button>
      </form>

      <div class="auth-secure">
        <span class="line"></span>
        <span class="txt"><i class="pi pi-shield"></i> Secure sign-in</span>
        <span class="line"></span>
      </div>

      <div class="auth-trust">
        <i class="pi pi-verified"></i>
        <span><b>Trusted by healthcare professionals</b> across the nation</span>
      </div>

      <div class="auth-powered">
        <span>Powered by</span>
        <span class="lapitech-badge">
          <img src="../../../assets/lapitech-logo-full.png?v=2" alt="Lapitech Software Solutions" />
        </span>
      </div>
    </div>
  </main>
</div>

<!-- ===================== OTP VERIFICATION MODAL ===================== -->
<p-dialog [visible]="showOtpModal()" (visibleChange)="showOtpModal.set($event)" [modal]="true"
    [draggable]="true" [resizable]="false" [closable]="true" [dismissableMask]="false"
    [closeOnEscape]="false" (onShow)="onOtpModalShow()" styleClass="otp-dialog"
    [style]="{ width: '420px' }" [breakpoints]="{ '480px': '92vw' }">
    <ng-template pTemplate="header">
        <div class="otp-header">
            <h3 class="otp-title mb-1">Verify OTP</h3>
            <p class="otp-subtitle mb-0">
                Enter the 6-digit code sent to <strong>{{ mobile() }}</strong>
            </p>
        </div>
    </ng-template>

    <div class="otp-body">
        <div class="otp-inputs" (paste)="onPaste($event)">
            @for (ctrl of otpArray.controls; track i; let i = $index) {
                <input #otpInput type="text" inputmode="numeric" maxlength="1"
                    class="otp-box" [formControl]="ctrl"
                    (input)="onInput($event, i)" (keydown)="onKeyDown($event, i)">
            }
        </div>

        <div class="otp-meta">
            <span class="otp-timer" [class.expired]="expired()">
                @if (expired()) { OTP expired } @else { Expires in {{ countdown() }} }
            </span>
            <button type="button" class="otp-resend" (click)="resendOtp()" [disabled]="resendLoading()">
                @if (resendLoading()) {
                    <span class="spinner-border spinner-border-sm me-1"></span> Sending...
                } @else {
                    Resend OTP
                }
            </button>
        </div>

        <div class="otp-actions">
            <button type="button" class="btn btn-outline-secondary" (click)="closeOtpModal()">
                Cancel
            </button>
            <button type="button" class="btn btn-primary" (click)="verifyOtp()"
                [disabled]="otpLoading() || expired()">
                @if (otpLoading()) {
                    <span class="spinner-border spinner-border-sm me-2"></span>
                    Verifying...
                } @else {
                    Verify &amp; Login
                }
            </button>
        </div>
    </div>
</p-dialog>
